import { Component, computed, Signal } from '@angular/core';
import { Router } from '@angular/router';
import { LocalStorageService } from '../shared/local-storage.service';
import { HMSDelivery } from '../shared/hms-delivery.model';

@Component({
    selector: 'app-hms-draft',
    templateUrl: './hms-draft.component.html',
    styleUrl: './hms-draft.component.css',
    standalone: false
})
export class HmsDraftComponent {

  drafts: Signal<HMSDelivery[]>;
   
  constructor(public dataSync: LocalStorageService, public router: Router) {
    this.drafts = computed(() => this.dataSync.hms_drafts())
   }
  
   onDraftClick(index: number) {
      this.router.navigate(['hms_delivery_detail', 3, index], { queryParams: { previous: 'hms_drafts' } })
    if ((document.documentElement.scrollTop || document.body.scrollTop) > 0) window.scrollTo(0, 0);
    }
  
}
